module.exports = __webpack_public_path__ + "amcharts/images/dragIconRectSmallBlack.svg";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/dragIconRectSmallBlack.svg
// module id = 241
// module chunks = 0